import { css } from '@compiled/react';

import { LoomOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';

import { CreateASiteText } from '../../components/create-a-site-heading';
import { Headings } from '../../components/headings';
import { SitesAreSharedSpacesText } from '../../components/sub-heading';

// Loom logged-in signup for brand-new users (no existing sites). Mirrors the
// Jira/Confluence new-user structure while keeping the Loom backdrop and Loom
// copy ("Create a site" + Loom sub-heading).
export const LoggedInLoomNewUser = () => (
	<LoomOverlayTemplate size="sm">
		<div css={containerCss}>
			<Headings main={<CreateASiteText />} sub={<SitesAreSharedSpacesText />} />
			<SiteActivation useContactExpandCohortLogic />
		</div>
	</LoomOverlayTemplate>
);

const containerCss = css({
	display: 'grid',
	gap: '10px',
});
